var n = Object.defineProperty;
var c = (r, s, t) => s in r ? n(r, s, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[s] = t;
var a = (r, s, t) => c(r, typeof s != "symbol" ? s + "" : s, t);
class i extends Error {
  constructor(t, o, e) {
    super(t);
    a(this, "info");
    a(this, "status");
    this.name = "HttpError", this.info = o, this.status = e;
  }
}
const u = async (...r) => {
  const s = await fetch(...r);
  if (!s.ok) {
    let t = {};
    try {
      t = await s.json();
    } catch (e) {
      t = {
        message: "Failed to parse response as JSON",
        detail: e
      };
    }
    throw new i(
      `HTTP error! status: ${s.status}`,
      t,
      s.status
    );
  }
  return s.json();
};
export {
  i as H,
  u as f
};
